export default {"src":"/_next/static/media/c.0ffdbd71.svg","height":288,"width":256,"blurWidth":0,"blurHeight":0};